
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.312 2.637l6.01 6.01-2.758 2.758-6.01-6.01 2.758-2.758z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M26.8 12L22 7.2c-.4-.4-1-.4-1.4 0L4.9 22.8c-.1.1-.1.2-.2.3v.1l-2.4 7.3c-.1.4 0 .8.2 1 .2.2.4.3.7.3.1 0 .2 0 .3-.1l7.3-2.4h.1c.1 0 .2-.1.3-.2l15.6-15.6c.4-.4.4-1.1 0-1.5zm-22 17.2l1.3-3.9 2.6 2.6-3.9 1.3zm5.7-2.3L7 23.4 21.2 9.3l3.5 3.5-14.2 14.1z","fill":"#47AEA6"}})])
          )
        }
      }
    